import { MinzeElement, Attrs } from 'minze'

export interface LvcHandDrawnButton {
  label: string
  description: string
  url: string
}

export class LvcHandDrawnButton extends MinzeElement {
  attrs: Attrs = [
    ['label', null],
    ['description', null],
    ['url', null],
  ]
  static observedAttributes = ['label', 'description', 'url']

  html = () => `
    <a href="${this.url}" class="hand-drawn-button">
      <lvc-hand-drawn-box variant="button1" hoverBgFromColor="#DCFFD7" hoverBgToColor="#89F27A">
        <div class="hand-drawn-button-content">
          <!-- Content -->
          <slot name="icon"></slot>
          <div class="hand-drawn-button-text">
            <div class="hand-drawn-button-label">${this.label}</div>
            ${
              this.description
                ? /* html */ `
              <div class="hand-drawn-button-description">${this.description}</div>
            `
                : ''
            }
          </div>
          <div class="hand-drawn-button-arrow">
            <lvc-arrow-right-icon width="34px" height="11px"></lvc-arrow-right-icon>
          </div>
        </div>
      </lvc-hand-drawn-box>
    </a>
  `

  css = () => `
    :host {}

    .hand-drawn-button {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      font-size: 1em;
      text-decoration: none;
    }

    .hand-drawn-button-content {
      position: relative;
      display: flex;
      gap: 20px;
      padding: 10px;
      color: #1E007D;
    }

    ::slotted([slot=icon]) {
      height: 40px;
    }

    .hand-drawn-button-label {
      font-size: 1.125em;
      font-weight: 800;
      line-height: 120%;
      text-transform: uppercase;
    }

    .hand-drawn-button-description {
      font-size: 0.750em;
      font-weight: 500;
      line-height: 120%;
    }

    .hand-drawn-button-arrow {
      margin-left: auto;
    }

    lvc-arrow-right-icon {
      transform: rotate(-35deg)
    }

    .hand-drawn-button:hover .hand-drawn-button-background:before {
      background: linear-gradient(269.53deg, #89F27A 0%, #DCFFD7 97.48%)
    }

    @media only screen and (max-width: 991px) {
      .hand-drawn-button-arrow {
        display: none;
      }
    }

    @media only screen and (min-width: 992px) {
      .hand-drawn-button-content {
        align-items: center;
        padding: 10px 20px;
      }

      .hand-drawn-button-label {
        font-size: 1.375em;
      }

      .hand-drawn-button-description {
        font-size: 0.875em;
      }
    }
  `
}
